import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { withRouter } from 'react-router-dom';
import { DeleteOutlined, EditOutlined, EyeOutlined, FileOutlined, UserOutlined } from '@ant-design/icons';
import { Modal, Tooltip, Tag, Button, Typography, Row, Spin, Collapse, Col, Card, Divider, Descriptions } from 'antd';
import { checkPermission } from '../../../utils/permission';
import { repeatPhoneNumber, isValidDate } from '../../../utils/helpers';
import HtmlParser from 'react-html-parser';
import ConsultantDetail from './ConsultantDetail';
import UpdateResultForm from './UpdateResultForm';
import HandlePhoneNumber from '../../../components/HandlePhoneNumber';
import { getListCustomerConsultantDirect, getSpecificCustomerConsultantDirect, removeCustomerConsultantDirect } from '../../../redux/actions/CustomerConsultantDirectActions';
import ConsultantForm from './ConsultantForm';

const { Panel } = Collapse;
const { Paragraph } = Typography;
const { confirm } = Modal;

class ConsultantList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            openUpdateResult: false,
            currentItem: null,
            loadingDetail: false,
            openDetail: false,
            current_id: null,
            consultant_list: [],
            pagination: {
                currentPage: 1,
                total: 0,
                perPage: 30
            }
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        this.setState({ isLoading: true });
        this.props.getListCustomerConsultantDirect().then((res) => {
            this.setState({
                consultant_list: res.data.data,
                pagination: {
                    currentPage: parseInt(res.data.current_page),
                    total: parseInt(res.data.total),
                    perPage: parseInt(res.data.per_page),
                },
                isLoading: false
            });
        })
    }

    toggleOpenForm(isOpenEditForm, currentItem = null) {
        this.setState({
            isOpenEditForm: isOpenEditForm,
            currentItem: currentItem,
        });
    }

    onEdit(id) {
        this.props.getSpecificCustomerConsultantDirect(id).then(res => {
            this.toggleOpenForm(true, res);
        })
    }

    toggleDetail(openDetail, data = null) {
        this.setState({ openDetail: openDetail, currentItem: data });
    }

    onDetail(id) {
        this.setState({ current_id: id, loadingDetail: true })
        this.props.getSpecificCustomerConsultantDirect(id).then(res => {
            this.setState({ loadingDetail: false })
            this.toggleDetail(true, res);
        })
    }

    openUpdateResult(id) {
        this.props.getSpecificCustomerConsultantDirect(id).then(res => {
            this.setState({ currentItem: res, openUpdateResult: true, require_field: res.status })
        })
    }

    onCancel() {
        this.loadData()
        this.setState({
            openUpdateResult: false,
            currentItem: null,
            isLoading: false
        })
    }

    onRemove = (ids) => {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeCustomerConsultantDirect(ids).then(() => {
                this.loadData();
            }),
            onCancel() { },
        });
    }

    render() {
        var {
            consultant_list,
            isLoading,
            currentItem, current_id,
            loadingDetail,
            openUpdateResult,
            openDetail,
            isOpenEditForm
        } = this.state;

        return (
            <div>
                {
                    consultant_list && consultant_list?.length ? (
                        <Spin tip="Loading..." spinning={isLoading}>
                            <Row gutter={16}>
                                <Col xs={24} md={24} className='box-item-mobile box-item-mobile-header'>
                                    <Card size="small"
                                        title={<strong>Tư vấn trực tiếp</strong>}
                                        bordered={false}
                                        headStyle={{ border: 0 }}
                                    ></Card>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                {
                                    consultant_list?.map((item, index) => {
                                        var bgcolor = "#f5b22d";
                                        var text2 = "Chưa trả kết quả"
                                        if (item.consultant_direct_status == 1) {
                                            bgcolor = "green";
                                            text2 = "Đã trả kết quả"
                                        }
                                        return (
                                            <Col key={index} xs={24} md={12} lg={8} className='box-item-mobile'>
                                                <Card size="small"
                                                    title={<>{<UserOutlined />} {item.customer_name}</>}
                                                    extra={
                                                        <>
                                                            {checkPermission('customer_consultant_direct', 'update') ? (
                                                                <a onClick={() => this.onEdit(item.schedule_consultant_id)} type="link" key="list-vertical-edit">
                                                                    <EditOutlined /> Sửa
                                                                </a>
                                                            ) : null}

                                                            {checkPermission('customer_consultant_direct', 'remove') ? (
                                                                <>
                                                                    <Divider type='vertical' />
                                                                    <span className='delete-icon' onClick={() => this.onRemove([item.schedule_consultant_id])} type="link" key="list-vertical-delete">
                                                                        <DeleteOutlined /> Xóa
                                                                    </span>
                                                                </>
                                                            ) : null}
                                                            <Divider type='vertical' />
                                                            <span className='item-action-btn' onClick={() => this.onDetail(item.schedule_consultant_id)}>
                                                                <EyeOutlined /> Xem
                                                            </span>
                                                        </>
                                                    }
                                                    bodyStyle={{ paddingBottom: 0 }}
                                                >
                                                    <Row gutter={16}>
                                                        <Col xs={24} md={24}>
                                                            <Descriptions size="small">
                                                                <Descriptions.Item label="Mã khách hàng">
                                                                    <Paragraph style={{ margin: 0 }} copyable={
                                                                        {
                                                                            text: item ? item.customer_code : null,
                                                                            tooltips: false
                                                                        }
                                                                    }>
                                                                        {item.customer_code}
                                                                    </Paragraph>
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                            <Divider className='no-margin' />
                                                        </Col>
                                                        <Col xs={24} md={24}>
                                                            <Descriptions size="small">
                                                                <Descriptions.Item label="Điện thoại">
                                                                    <HandlePhoneNumber
                                                                        permission={checkPermission('customer', 'phonenumber')}
                                                                        inputPinCode={checkPermission('customer', 'input_pin_code')}
                                                                        customer_id={item?.customer_id}
                                                                        hiddenPhoneNumber={repeatPhoneNumber(item.customer_phone)}
                                                                        fullPhoneNumber={item.customer_phone}
                                                                    />
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                            <Divider className='no-margin' />
                                                        </Col>
                                                        <Col xs={24} md={24}>
                                                            <Descriptions size="small">
                                                                <Descriptions.Item label="Trạng thái khách hàng">
                                                                    {
                                                                        item.customer_status_color ? (
                                                                            <Tag color={item.customer_status_color}>{item.customer_status}</Tag>
                                                                        ) : (
                                                                            <Tag>{item.customer_status}</Tag>
                                                                        )
                                                                    }
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                            <Divider className='no-margin' />
                                                        </Col>
                                                        <Col xs={24} md={24}>
                                                            <Descriptions size="small">
                                                                <Descriptions.Item label="Trạng thái">
                                                                    {
                                                                        checkPermission('customer_consultant_direct', 'update_result') ? (
                                                                            <Tooltip title="Click để cập nhật" placement="right">
                                                                                <Button icon={<EditOutlined />}
                                                                                    style={{ background: bgcolor, color: '#fff', border: 'none' }}
                                                                                    onClick={() => this.openUpdateResult(item.schedule_consultant_id)}
                                                                                    size='small'>
                                                                                    {text2}
                                                                                </Button>
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <Button style={{ background: bgcolor, color: '#fff', border: 'none' }} size='small'>
                                                                                {text2}
                                                                            </Button>
                                                                        )
                                                                    }
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                            <Divider className='no-margin' />
                                                        </Col>
                                                        <Col xs={24} md={24}>
                                                            <Descriptions size="small">
                                                                <Descriptions.Item label="Thời điểm tư vấn">
                                                                    {isValidDate(item.time_consultant)}
                                                                </Descriptions.Item>
                                                            </Descriptions>
                                                            <Divider className='no-margin' />
                                                        </Col>
                                                        <Col xs={24} md={24} className='customer-telesale-box'>
                                                            <Collapse
                                                                expandIconPosition="end"
                                                                ghost
                                                                defaultActiveKey={[]}
                                                            >
                                                                <Panel
                                                                    header={<><span className="font-weight-500"><FileOutlined /> Kết quả tư vấn</span></>}
                                                                    key="1"
                                                                >
                                                                    {HtmlParser(item.result_content)}
                                                                </Panel>
                                                            </Collapse>
                                                        </Col>
                                                        <Col xs={24} md={24} className='customer-telesale-box no-border'>
                                                            <Collapse
                                                                expandIconPosition="end"
                                                                ghost
                                                                defaultActiveKey={[]}
                                                            >
                                                                <Panel
                                                                    header={<><span className="font-weight-500"><FileOutlined /> Ghi chú</span></>}
                                                                    key="1"
                                                                >
                                                                    {HtmlParser(item.note)}
                                                                </Panel>
                                                            </Collapse>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                        )
                                    })
                                }
                            </Row>
                        </Spin>
                    ) : null
                }

                <ConsultantDetail
                    visible={openDetail}
                    currentItem={currentItem}
                    reloadData={() => this.onDetail(current_id)}
                    onCancel={() => this.toggleDetail(false)}
                    reloadList={() => this.loadData()}
                    loadingDetail={loadingDetail}
                />
                <UpdateResultForm
                    visible={openUpdateResult}
                    currentItem={currentItem}
                    reloadData={() => this.loadData()}
                    onCancel={() => this.onCancel()}
                />
                <ConsultantForm
                    visible={isOpenEditForm}
                    currentItem={currentItem}
                    reloadData={() => this.loadData()}
                    onCancel={() => this.setState({ isOpenEditForm: false })}
                />
            </div >
        )
    }
}

function mapStateToProps(state) {
    return {

    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListCustomerConsultantDirect: (filter) => dispatch(getListCustomerConsultantDirect(filter)),
        getSpecificCustomerConsultantDirect: (id) => dispatch(getSpecificCustomerConsultantDirect(id)),
        removeCustomerConsultantDirect: (id) => dispatch(removeCustomerConsultantDirect(id))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'ConsultantList' })(ConsultantList)));

